import { applyMiddleware, combineReducers, compose, createStore, Store } from 'redux';

import { RootState } from './rootState';
import { AppState } from './appState';
import { mainReducer } from './actionsHandler';
import thunk from 'redux-thunk';
import { connectRouter } from 'connected-react-router';
import { History } from "history";
import promiseMiddleware from './promiseMiddleware';
import { Reducer } from 'react';

export default function configureStore(initialState: AppState, history: History): Store<RootState, any> {
    const middleware = [
        thunk,
        promiseMiddleware
    ];

    const getRootReducer = (history: History): Reducer<RootState, any> => combineReducers<RootState>({
        router: connectRouter(history),
        appState: mainReducer,
    });
    const rootReducer = getRootReducer(history);

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.NODE_ENV === 'development';

    /* eslint-disable no-underscore-dangle */
    if (isDevelopment && typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push((window as any).__REDUX_DEVTOOLS_EXTENSION__());
    }
    /* eslint-enable */

    const store = createStore(
        rootReducer,
        {
            router: history,
            appState: initialState,
        } as unknown as RootState,
        compose(applyMiddleware(...middleware), ...enhancers)
    );

    return store;
}
